import { render, staticRenderFns } from "./TradeList.vue?vue&type=template&id=86d1d3b0&scoped=true&"
import script from "./TradeList.vue?vue&type=script&lang=js&"
export * from "./TradeList.vue?vue&type=script&lang=js&"
import style0 from "./TradeList.vue?vue&type=style&index=0&id=86d1d3b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d1d3b0",
  null
  
)

export default component.exports